import { render, staticRenderFns } from "./ProfilMenu.vue?vue&type=template&id=3ef3a8ef&scoped=true&"
import script from "./ProfilMenu.vue?vue&type=script&lang=ts&"
export * from "./ProfilMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilMenu.vue?vue&type=style&index=0&id=3ef3a8ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3a8ef",
  null
  
)

export default component.exports